import React from "react";
import notFound from "../../assets/notFound.svg";
import Flexbox from "flexbox-react";


const PageSubheading = ({ logo,subheading }) => {
  return (
    <Flexbox flexDirection="row" justifyContent="center"  alignItems="center" className="">
      <Flexbox alignItems="flex-start" className="page-header" width="100%">
          <img src={logo} />
          <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
  >
    <path
      d="M1 6.55556L3.77778 3.77778L1 1"
      stroke="#3B5998"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 16.5556L3.77778 13.7778L1 11"
      stroke="#3B5998"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.77777 2.11108H21"
      stroke="#3B5998"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.77777 8.77783H21"
      stroke="#3B5998"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.77777 15.4445H21"
      stroke="#3B5998"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

  <p className="sub-heading">{subheading}</p>
</Flexbox>
       

    </Flexbox>
  );
};

export default PageSubheading;








